import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '9rem',
    minWidth: '50rem',
  },
  title: {
    fontSize: '1.2rem',
    marginTop: 0,
  },
  form: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  buttons: {
    marginTop: '0.5rem',
    flexGrow: 1,
    display: 'flex',
  },
}));

export default useStyles;
